import Vue from 'vue'
import router from '@router/index'
import * as Sentry from '@sentry/vue'
import { SENTRY_DSN, SENTRY_PROJECT_ID } from '@constants/credentials'
import { FORCE_SENTRY } from '../constants/appConfig'
import { version } from '@/package.json'

const isProduction = process.env.NODE_ENV === 'production'

// Still reported, but not worth one of the plan's 50 replays: the browser sees the same 500 or 502
// whether Knack failed or one of our Netlify functions did, and a replay doesn't show which.
const SERVER_ERROR = /Request failed with status code 50[02]\b/

if (isProduction || FORCE_SENTRY) {
  Sentry.init({
    release: 'wci-knack-v2@' + version,
    Vue,
    dsn: 'https://' + SENTRY_DSN + '.ingest.sentry.io/' + SENTRY_PROJECT_ID,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay({
        beforeErrorSampling: (event) =>
          !(event.exception?.values || []).some(({ value }) => SERVER_ERROR.test(value || '')),
      }),
    ],
    environment: isProduction ? 'production' : 'development',
    // tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // tracesSampleRate: 0.5,
    tracesSampleRate: isProduction ? 0.25 : 1.0,
    // Session Replay
    // The plan allows 50 replays a month; random sessions used them up within hours,
    // so record only sessions that hit an error.
    replaysSessionSampleRate: 0,
    // Sampled per error, not per session, so a session with several errors is likelier to be
    // recorded. September's errors, less the filtered ones and 500s/502s, come to about 44
    // replays a month at 0.2: under the 50, and spread across the month.
    replaysOnErrorSampleRate: 0.2,
    ignoreErrors: [
      /Function statements (require a function name|must have a name)|function statement requires a name/,
      /Loading chunk [\d]+ failed/,
      /Loading CSS chunk \S+ failed/,
      /ChunkLoadError/,
      /Unexpected token '<'/,
      // Knack being slow or unreachable, or the user losing signal. Expected, and not fixable here.
      /timeout of \d+ms exceeded/,
      /Network Error/,
    ],
  })
}
